import { Box, Button, Card, Container, FormLabel, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';

import {
  createBanner,
  createChatSettings,
  createContactInfo,
  createShellySettings,
  deleteUploads,
  getBanner,
  getChatSettings,
  getContactInfo,
  getShellySettings,
  uploadFile,
} from '../helper/backend_helper';
import appConfig from '../config';
import InfoTooltip from '../components/InfoTooltip';

// import logo from 'src/components/logo';

const ShellySetting = () => {
  const [chatSettingsData, setChatSettingsData] = useState({});

  const [phoneId, setPhoneId] = useState('');
  const [productId, setProductId] = useState('');
  const [token, setToken] = useState('');
  const [senderPhoneNumber, setSenderPhoneNumber] = useState('');
  const [senderName, setSenderName] = useState('');

  const [loading, setLoading] = useState(false);

  const Banner = async () => {
    try {
      const bannerResponse = await getChatSettings();
      setChatSettingsData(bannerResponse?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    Banner();
  }, []);
  useEffect(() => {
    setPhoneId(chatSettingsData?.phoneId || '');
    setProductId(chatSettingsData?.productId || '');
    setToken(chatSettingsData?.token || '');
    setSenderPhoneNumber(chatSettingsData?.senderPhoneNumber || '');
    setSenderName(chatSettingsData?.senderName || '');
  }, [chatSettingsData]);

  const handleSave = async () => {
    try {
      setLoading(true);

      // Check if any field is empty
      if (phoneId.trim() === '') {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Phone ID cannot be empty',
        });
        setLoading(false);
        return;
      }

      if (productId.trim() === '') {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Product ID cannot be empty',
        });
        setLoading(false);
        return;
      }
      if (token.trim() === '') {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Token cannot be empty',
        });
        setLoading(false);
        return;
      }

      const BannerData = {
        phoneId: phoneId.trim(),
        productId: productId.trim(),
        token: token.trim(),
        senderPhoneNumber,
        senderName,
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createChatSettings(BannerData, Categoryheaders);

      // setTitle('');
      // setFormData({
      //   ...formData,
      //   profileImage: null,
      // });

      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'Chat Settings updated successfully',
      });

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error while updating Chat Settings',
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Chat Settings </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          // onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <Typography variant="h4">
            Chat Settings{' '}
            <InfoTooltip
              width={20}
              title="The WhatsApp Business API connection used to send all automated guest messages. It stores the phone ID, product ID and access token that authorise outgoing messages, plus the sender phone number and name that guests see. Enter these credentials and the sender details here and Update to enable or change how chat messages are delivered."
            />
          </Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: '60ch' },
          }}
          noValidate
          autoComplete="off"
        >
          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Phone ID<InfoTooltip title="WhatsApp Business phone number ID used to send messages through the messaging API." /></FormLabel>
              <TextField
                label="Enter Phone ID"
                id="outlined-size-small"
                value={phoneId}
                onChange={(e) => setPhoneId(e.target.value)}
              />
            </Stack>
          </Stack>
          <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Product ID<InfoTooltip title="Identifier of the messaging product or app registered with the WhatsApp Business provider." /></FormLabel>
              <TextField
                label="Enter Product ID"
                id="outlined-size-small"
                value={productId}
                onChange={(e) => setProductId(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Token<InfoTooltip title="Secret access token that authorises the app to send messages via the WhatsApp Business API." /></FormLabel>
              <TextField
                label="Enter Token"
                id="outlined-size-small"
                value={token}
                onChange={(e) => setToken(e.target.value)}
              />
            </Stack>
          </Stack>

          <Typography variant="h6" sx={{ mt: 3 }}>
            Bind Sender Details
          </Typography>

          <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Sender Phone Number<InfoTooltip title="Phone number guests see as the sender of outgoing chat messages." /></FormLabel>
              <TextField
                label="Enter Phone Number"
                id="outlined-size-small"
                value={senderPhoneNumber}
                onChange={(e) => setSenderPhoneNumber(e.target.value)}
              />
            </Stack>
          </Stack>
          <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Sender Name<InfoTooltip title="Display name guests see as the sender of outgoing chat messages." /></FormLabel>
              <TextField
                label="Enter Sender Name"
                id="outlined-size-small"
                value={senderName}
                onChange={(e) => setSenderName(e.target.value)}
              />
            </Stack>
          </Stack>
        </Box>
        <LoadingButton
          sx={{
            // width: 150,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Update
        </LoadingButton>
      </Card>
    </>
  );
};

export default ShellySetting;
